<script setup lang="ts">
import { computed } from 'vue';
import { classNames } from '@/js/lib/bem';

const props = withDefaults(
  defineProps<{
    size?: 'xl' | 'lg' | 'md' | 'sm' | 'xs'
  }>(),
  {
    size: 'md',
  },
);

const cn = classNames('base-title');

const titleClasses = computed(() => cn({ size: props.size }));
</script>

<template>
  <p :class="titleClasses">
    <slot />
  </p>
</template>
